export default __webpack_public_path__ + "static/media/promo-dining.95132dfc.jpg";